<div class="container">
  <div class="text">
    <p [ngClass]="getCssClass()">{{ label | translate }}</p>
    <p *ngIf="description" class="description">{{ description | translate }}</p>
  </div>
  <app-toggle [disabled]="disabled" [checked]="value" (toggleChange)="handleModelChange($event)"></app-toggle>
</div>
